import supabase from "@/services/supabaseClient.js";

export async function submitContextFeedback({
  userId = "",
  role = "",
  route = "",
  section = "",
  context = {},
  message = "",
  feedbackType = "suggestion",
} = {}) {
  const cleanUserId = String(userId || "").trim();
  const cleanMessage = String(message || "").trim();
  const cleanRoute = String(route || "").trim();
  const cleanRole = String(role || "").trim().toLowerCase();

  if (!cleanUserId || !cleanMessage || !cleanRoute || !cleanRole) {
    throw new Error("AfriMed needs your route, role, and a short note to save this feedback.");
  }

  const cleanFeedbackType = String(feedbackType || "suggestion").trim().toLowerCase();
  const { data, error } = await supabase.functions.invoke("submit-context-feedback", {
    body: {
      user_id: cleanUserId,
      role: cleanRole,
      route: cleanRoute,
      section: String(section || "").trim() || null,
      context_json: context && typeof context === "object" ? context : {},
      message: cleanMessage,
      feedback_type: cleanFeedbackType,
    },
  });
  if (error) throw error;
  if (data?.ok === false) {
    throw new Error(String(data?.error || "AfriMed could not save this suggestion yet."));
  }
  return data;
}
